import { Amplify } from 'aws-amplify';
import { COGNITO_CONFIG } from './api';

// Use COGNITO_CONFIG as the single source of truth — it already has
// hardcoded fallbacks so the build works without .env files.
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: COGNITO_CONFIG.userPoolId,
      userPoolClientId: COGNITO_CONFIG.clientId,
      loginWith: {
        oauth: {
          domain: COGNITO_CONFIG.domain,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [COGNITO_CONFIG.redirectUri],
          redirectSignOut: [COGNITO_CONFIG.logoutUri],
          responseType: 'code',
        },
      },
    },
  },
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
